<template>
    <Transition name="slide-fade" @enter="onTransitionEnter" @after-leave="onTransitionAfterLeave">
        <div
            v-if="isOpen"
            class="position-fixed left-0 top-0 w-100 h-100 z-index-500 d-flex flex-row user-modal-container"
            :class="containerClass"
        >
            <div class="col-sm-2 col-md-2 col-lg-1 hidden-xs" @click.prevent.stop="closeModal"></div>

            <div
                class="bg-gray-light p-10 d-flex flex-grow-1 position-relative"
                :id="identifier + '-content'"
                :class="contentWrapperClass"
            >
                <span
                    data-user-modal-close
                    class="position-absolute cursor-pointer user-modal-close"
                    @click.prevent.stop="closeModal"
                ></span>

                <div class="d-flex w-100 align-items-center justify-content-center overflow-auto">
                    <div id="promiseCaptchaContainer"></div>
                    <LoadingAnimation
                        animation-style="bars"
                        v-if="isLoading"
                        id="user-modal-loading-animation"
                    ></LoadingAnimation>

                    <template v-else>
                        <Transition :name="transitionName">
                            <KeepAlive :include="keepAliveViews">
                                <RouterView
                                    class="h-max-100 py-3"
                                    :key="$route.fullPath"
                                    @modal-close="closeModal"
                                ></RouterView>
                            </KeepAlive>
                        </Transition>
                    </template>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script>
import LoadingAnimation from '../../../qaamgo/modules/sat/components/LoadingAnimation';

export default {
    name: 'UserModal',
    components: { LoadingAnimation },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        isLoading: {
            type: Boolean,
            required: true,
        },
        containerClass: {
            type: String,
            default: '',
        },
        identifier: {
            type: String,
            required: true,
        },
        contentWrapperClass: {
            type: String,
            default: '',
        },
        keepAliveViews: {
            type: String,
            default: '',
        },
        transitionName: {
            type: String,
            default: 'slide-fade-left',
        },
    },
    methods: {
        onTransitionEnter() {
            let scrollbarWidth = window.innerWidth - document.body.clientWidth + 'px';

            document.body.setAttribute('style', `padding-right:${scrollbarWidth};overflow:hidden;`);
        },
        onTransitionAfterLeave() {
            document.body.removeAttribute('style');
        },
        closeModal() {
            this.$emit('modal-close');
        },
    },
};
</script>
